export default class Click {
  constructor() {
    this.init()
  }

  init() {
    this.getParam()
    this.bindEvent()
  }

  /**
  ** 各種要素を取得している
  ** @getParam
  **/
  getParam() {
    this.more =  document.querySelectorAll(`[data-module='more-module']`)
    this.arrayMore = Array.prototype.slice.call(this.more)
    this.hrefInsert = 'href="#bestsale'
    this.breakPoint = matchMedia('(min-width:769px)')
  }
  

  /**
  ** ボタンを押下し、非表示になっているアイテムを表示する
  ** @bindEvent
  **/  
  bindEvent() {
    Array.prototype.forEach.call(this.arrayMore,(elem)=> {
      const
        toggle = elem.querySelector(`[data-module='more-toggle']`),
        toggleHref = toggle.getAttribute('data-href'),
        toggleHash = toggle.getAttribute('href'),
        toggleParagraph = elem.querySelector(`[data-module='more-toggle'] > p`),
        toggleParagraphText = toggleParagraph.textContent,
        item = elem.querySelectorAll(`[data-module='more-item']`),
        itemLength = item.length,
        itemArray = Array.prototype.slice.call(item)



      if(itemLength > 9) {

        const cliclclickcclck =() => {
          toggle.addEventListener('click', (e)=> {
            if(!toggle.classList.contains('is-show')) {
              toggle.setAttribute('href', '')

              e.preventDefault();
              toggleParagraph.innerText = '閉じる'
              toggle.classList.add('is-show')
            }
            else {
              toggle.setAttribute('href', toggleHash)
              toggle.classList.remove('is-show')
              toggleParagraph.innerText = toggleParagraphText
            }
    
    
            Array.prototype.forEach.call(itemArray,(childElem)=> {
              let
                HideBool = document.defaultView.getComputedStyle(childElem,null).display
    
              if(HideBool === 'none') {
                childElem.classList.add('is-show')
              } else {
                childElem.classList.remove('is-show')
              }
            })
          })  
        }

        if(this.breakPoint.matches) {
          toggle.setAttribute('href', '')

          cliclclickcclck()
  
      
        } else {

          if(toggleHref.length === 0) {
            cliclclickcclck()
          } else {
            toggle.setAttribute('href', toggleHref)
            toggle.removeAttribute('data-scroll') 
          }
        }
      } else {
        toggle.remove()
      }
    })
  }

}   
